import { render } from "./MainDropdown.vue?vue&type=template&id=4517b3e8"
import script from "./MainDropdown.vue?vue&type=script&lang=js"
export * from "./MainDropdown.vue?vue&type=script&lang=js"

import "./MainDropdown.vue?vue&type=style&index=0&id=4517b3e8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__